import "./Styles/listing-events.scss";
import "react-toggle/style.css";

import config from "../../app.json";
import axios from "axios";

import Pagination from "../../Components/Pagination/pagination";

import { Context } from "../../Reducers/Store";
import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import AlertComponent from "../../Components/AlertComponent";
import VideoArchiveCard from "../../Components/VideoArchiveCard/VideoArchiveCard";
import FieldSelect from "../../Components/Fields/FieldSelect";
import FieldDatepicker from "../../Components/Fields/FieldDatepicker";

function VideoArchive() {
  let navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const [cards, setCards] = useState([]);

  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [channel, setChannel] = useState(null);
  const [channels, setChannels] = useState([]);
  const [series, setSeries] = useState(null);
  const [seriesOptions, setSeriesOptions] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [stopDate, setStopDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [finishLoad, setFinishLoad] = useState(false);

  const itemsPerPage = 8;

  const fetchEvents = () => {
    if (!finishLoad)
      return;

    axios.post(config.API + "/api/event/getEventsInstances", {
      page: currentPage,
      perPage: itemsPerPage,
      channelId: channel?.value,
      seriesId: series?.value == "general" ? null : series?.value,
      noSeries: series?.value == "general",
      startDate,
      stopDate
    }).then((res) => {
      if (res.status === 200 && res.data) {
        if (res.data.values.$values.length) {
          setTotalItems(res.data.total);
        } else {
          setTotalItems(0);
        }
        res.data.values.$values.map((i) => {
          if (!window._channelsIds.includes(i.channelId))
            window._channelsIds.push(i.channelId);
        });

        setCards(res.data.values.$values);
      }
    }).catch(function (error) {
      return AlertComponent(
        "Error",
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message,
        { icon: `error` }
      );
    });
  };

  useEffect(() => {
    var channelLocalStorage = sessionStorage.getItem("_videoArchive_channelId");
    if (channelLocalStorage) setChannel(JSON.parse(channelLocalStorage));
    var seriesLocalStorage = sessionStorage.getItem("_videoArchive_seriesId");
    if (seriesLocalStorage) setSeries(JSON.parse(seriesLocalStorage));
    var startLocalStorage = sessionStorage.getItem("_videoArchive_startDate");
    if (startLocalStorage) setStartDate(new Date(startLocalStorage));
    var stopLocalStorage = sessionStorage.getItem("_videoArchive_stopDate");
    if (stopLocalStorage) setStopDate(new Date(stopLocalStorage));
    var currentPageLocalStorage = sessionStorage.getItem("_videoArchive_currentPage");
    if (currentPageLocalStorage) setCurrentPage(parseInt(currentPageLocalStorage, 10));

    fetchChannels();
    fetchSeriesOptions();

    setFinishLoad(true);
  }, [0]);

  useEffect(() => {
    const totalPagesCalculated = Math.ceil(totalItems / itemsPerPage);
    setTotalPages(totalPagesCalculated);
  }, [totalItems]);

  useEffect(() => {
    fetchEvents();
    sessionStorage.setItem("_videoArchive_currentPage", currentPage);
  }, [currentPage, finishLoad]);

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleFilter = () => {
    sessionStorage.removeItem("_videoArchive_channelId");
    sessionStorage.removeItem("_videoArchive_seriesId");
    sessionStorage.removeItem("_videoArchive_startDate");
    sessionStorage.removeItem("_videoArchive_stopDate");

    if (channel)
      sessionStorage.setItem("_videoArchive_channelId", JSON.stringify(channel));

    if (series)
      sessionStorage.setItem("_videoArchive_seriesId", JSON.stringify(series));

    if (startDate)
      sessionStorage.setItem("_videoArchive_startDate", startDate.toISOString());

    if (stopDate)
      sessionStorage.setItem("_videoArchive_stopDate", stopDate.toISOString());

    if (currentPage == 0) {
      fetchEvents();
    }
    else
      setCurrentPage(0);
  }

  const fetchChannels = () => {
    axios.post(config.API + "/api/channel/getChannelsSelect").then((res) => {
      var parsed = res.data.$values?.map(x => { return { value: x.id, label: x.friendlyName || x.name } });
      setChannels(parsed);
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
  };

  const fetchSeriesOptions = () => {
    axios.post(config.API + "/api/series/getSeriesSelect").then((res) => {
      var parsed = res.data.$values?.map(x => { return { value: x.id, label: x.name } }) ?? [];
      setSeriesOptions([{ value: "general", label: "General" }, ...parsed]);
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
  };

  const paginationElement = cards && cards.length ? (
    <div className="pagination-container">
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onNextPage={nextPage}
        onPrevPage={prevPage}
      />
    </div>
  ) : null;

  return (
    <Row style={{ marginTop: 40 }}>
      <Col className="col-md-11">
        <Row className="filter">
          <Col md={12}>
            <div className="cc-card mb-4 p-4">
              <h5>Filter</h5>
              <Row>
                <Col md={3}>
                  <FieldSelect
                    label={`Channel`}
                    options={channels}
                    onChange={setChannel}
                    value={channel}
                    placeholder={`Channel`}
                    required={false}

                  />
                </Col>
                <Col md={2}>
                  <FieldSelect
                    label={`Series`}
                    options={seriesOptions}
                    onChange={setSeries}
                    value={series}
                    placeholder={`Series`}
                    required={false}
                  />
                </Col>
                <Col md={2}>
                  <FieldDatepicker
                    label={`Start Date`}
                    className={`datepicker w-100`}
                    placeholder={`Start Date`}
                    value={startDate}
                    onChange={setStartDate}
                    startDate={startDate}
                    endDate={stopDate}
                    maxDate={stopDate}
                  />
                </Col>
                <Col md={2}>
                  <FieldDatepicker
                    label={`End Date`}
                    className={`datepicker w-100`}
                    placeholder={`Stop Date`}
                    value={stopDate}
                    onChange={setStopDate}
                    minDate={startDate}
                    startDate={startDate}
                  />
                </Col>
                <Col style={{ marginTop: 27, display: 'flex', justifyContent: 'flex-start', height: 52 }}>
                  <Button className="dark-btn btn btn-primary" type="button" onClick={handleFilter}>
                    Apply Filter
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
          
        </Row>
        <Row className="listing-events-container">
          {cards?.map((x, index) => (
            <Col className="col-md-6 mb-4">
              <VideoArchiveCard
                {...x}
                currentPage={currentPage}
                refresh={() => fetchEvents()}
              />
            </Col>
          ))}
          {(!cards || !cards.length) && (
            <Col className="col-md-6">
              <div className="empty-state-card">
                There are no finalized events
              </div>
            </Col>
          )}

          {paginationElement}
        </Row>
      </Col>
    </Row>
  );
}

export default VideoArchive;
